import React from "react";
import Reveal from "../Reveal";

import foto1 from "../../assets/galeria/1.jpeg";
import foto2 from "../../assets/galeria/2.jpeg";
import foto3 from "../../assets/galeria/3.jpeg";
import foto4 from "../../assets/galeria/4.jpeg";
import foto5 from "../../assets/galeria/5.jpeg";
import foto6 from "../../assets/galeria/6.jpeg";
import foto7 from "../../assets/galeria/7.jpeg";
import foto8 from "../../assets/galeria/8.jpeg";
import foto9 from "../../assets/galeria/9.jpeg";
import foto11 from "../../assets/galeria/11.jpeg";
import foto12 from "../../assets/galeria/12.jpeg";
import foto13 from "../../assets/galeria/13.jpeg";
import foto14 from "../../assets/galeria/14.jpeg";
import foto15 from "../../assets/galeria/15.jpeg";
import foto16 from "../../assets/galeria/16.jpeg";
import foto17 from "../../assets/galeria/17.jpeg";
import foto18 from "../../assets/galeria/18.jpeg";


const slides = [
  { image: foto1 },
  { image: foto2 },
  { image: foto3 },
  { image: foto4 },
  { image: foto5 },
  { image: foto6 },
  { image: foto7 },
  { image: foto8 },
  { image: foto9 },
  { image: foto11 },
  { image: foto12 },
  { image: foto13 },
  { image: foto14 },
  { image: foto15 },
  { image: foto16 },
  { image: foto17 },
  { image: foto18 },
];

export default function Gallery() {
  return (
    <section
      id="galeria"
      data-testid="gallery-section"
      className="relative overflow-hidden py-24 sm:py-32 text-white bg-transparent"
    >
      <div className="container-pad relative z-10">
        <div className="max-w-3xl mb-14">
          <Reveal
            as="div"
            className="inline-block px-4 py-1.5 rounded-full bg-white/10 backdrop-blur-xl border border-white/15 text-white text-xs font-bold uppercase tracking-[0.18em] mb-5"
          >
            Galeria
          </Reveal>

          <Reveal
            as="h2"
            delay={80}
            className="font-heading text-3xl sm:text-4xl lg:text-5xl text-white tracking-tight leading-[1.1]"
          >
            Momentos felizes{" "}
            <span className="italic text-gold">de quem confia em nós</span>.
          </Reveal>
        </div>

        <Reveal
          as="div"
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
        >
          {slides.map((item, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-[32px] bg-white/10 backdrop-blur-xl border border-white/15 shadow-[0_25px_80px_rgba(0,0,0,0.25)] hover:-translate-y-1 hover:shadow-[0_35px_100px_rgba(0,0,0,0.35)] transition-all duration-500"
            >
              <img
                src={item.image}
                alt="Pet atendido pela Tia Sandra Pet Care"
                className="w-full h-80 object-cover transition duration-[1200ms] group-hover:scale-110"
              />

              <div className="absolute inset-0 bg-gradient-to-t from-royal/45 via-transparent to-transparent opacity-60 group-hover:opacity-35 transition-opacity" />

              <div className="absolute -top-24 -right-24 w-52 h-52 bg-gold/20 rounded-full blur-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
            </div>
          ))}
        </Reveal>
      </div>
    </section>
  );
}
